// Pure URL builder for contextual links into the Action Center
// (/alerts?entity_type=...&entity_id=...&status=...). Extracted once at
// least three host pages (SubstanceDetail, Warehouse, OperationsDetail)
// needed to build the exact same query string - see FE5 report.
//
// Callers still pass the internal uppercase enum values (entityType="DRUG",
// status="OPEN", matching the backend's own contract) - only the URL's
// public representation is lowercased here (see the FE lowercase-URL fix),
// mirroring EventAlertsPage's own read/write normalization.
const buildEventAlertsUrl = ({ entityType, entityId, status = "OPEN" } = {}) => {
  const params = new URLSearchParams();
  if (entityType) params.set("entity_type", entityType.toLowerCase());
  if (entityId !== undefined && entityId !== null && entityId !== "") {
    params.set("entity_id", String(entityId));
  }
  if (status) params.set("status", status.toLowerCase());
  return `/alerts?${params.toString()}`;
};

export { buildEventAlertsUrl };
